<template>
  <div class="login-wrap">
    <div class="ms-login">
      <el-tabs :stretch="true" v-model="activeName" @tab-click="onTabchange">
        <el-tab-pane label="账号登录" name="1">
        <!-- 账号密码登录 -->
        <div class="acc-login">
            <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0px" class="ms-content">
              <el-form-item class="ms_username" prop="username">
                <el-input v-model="loginForm.username" placeholder="username">
                  <el-button slot="prepend" icon="el-icon-lx-people"></el-button>
                </el-input>
              </el-form-item>
              <el-form-item class="ms_username2" prop="password">
                <el-input type="password" placeholder="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')">
                  <el-button slot="prepend" icon="el-icon-lx-lock"></el-button>
                </el-input>
              </el-form-item>
              <div class="login-btn">
                <el-button :loading="loading" type="primary" @click="submitForm('loginForm')">登录</el-button>
              </div>
              <!-- <p class="login-tips">Tips : 用户名和密码</p> -->
            </el-form>
        </div>
        </el-tab-pane>
        <el-tab-pane label="扫码(杭州)" name="2">
          <!-- 飞书扫码登录 -->
          <div id="login_container_hangzhou"></div>
        </el-tab-pane>
        <el-tab-pane label="扫码(山东)" name="3">
          <!-- 飞书扫码登录 -->
          <div id="login_container_shandong"></div>
        </el-tab-pane>
        <el-tab-pane label="新泰客服" name="4">
          <!-- 飞书扫码登录 -->
          <div id="login_container_shandong3"></div>
        </el-tab-pane>
        <el-tab-pane label="新泰用户" name="5">
          <!-- 飞书扫码登录 -->
          <div id="login_container_shandong2"></div>
        </el-tab-pane>
        <el-tab-pane label="济宁客服" name="6">
          <!-- 飞书扫码登录 -->
          <div id="login_container_shandong4"></div>
        </el-tab-pane>

        <div class="login-btn" v-if="activeName !== '1'">
            <el-button :loading="loading" type="primary" @click="onFsAuthLogin" class="fs-code-login-btn">
              飞书快速登录
            </el-button>
        </div>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { loginByUsername, getUserInfo, getFeishuUrl, feiLogin,feishuAuthLogin } from '@/api/login.js';
import { setToken, setName, setRoles, removeToken, setAdminId } from '@/utils/localStorage.js';
import { Loading } from 'element-ui';
import { getBaseUrl } from '@/config/index';
import { Base64 } from 'js-base64';
import { onCommonFsAuthLogin, getCommonFeishuAuthLogin } from '@wanxin-site/common-utils';
const provinceListAppid = {
  '2': 'cli_a157925b1338100e', // 杭州
  '3': 'cli_a289175033a4500b', // 山东
  '4': 'cli_a4acee32b07cd013', // 新泰客服
  '5': 'cli_a4acff177ff8100c', // 新泰用户
  '6': 'cli_a4dc9c3dd0e3d00b', // 济宁
};

const areaMap = {
  '2': 'hangzhou', // 杭州
  '3': 'shandong', // 山东
  '4': 'shandong3', // 新泰客服
  '5': 'shandong2', // 新泰用户
  '6': 'shandong4', // 济宁
};

export default {
  data: function () {
    return {
      /*
      1:账号密码登录
      2:飞书扫码登录
      */
      activeName: '1',
      loginForm: {
        username: '',
        password: '',
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      loading: false,
      redirect: undefined,
      url: '', // 飞书登录url
      timer: null,
      timeCount: 60, // 倒计时1分钟
      QRLoginObj: undefined,
      userType: '',
      hzReUrl: '',
      hz_unique_flag: '',
      sdReUrl: '',
      sd_unique_flag: '',
      sd2ReUrl: '',
      sd2_unique_flag: '',
      sd3ReUrl: '',
      sd3_unique_flag: '',
      sd4ReUrl: '',
      sd4_unique_flag: '',
    };
  },
  watch: {
    async activeName(newVal) {
      if (newVal == 1) return;
      if (newVal == 2) {
        this.userType = 'hangzhou';
      }
      if (newVal == 3) {
        this.userType = 'shandong';
      }
      if (newVal == 4) {
        this.userType = 'shandong3';
      }
      if (newVal == 5) {
        this.userType = 'shandong2';
      }
      if (newVal == 6) {
        this.userType = 'shandong4';
      }
      await this.initFeiShu();
      window.removeEventListener('message', this.handleMessage, false);
      let goto = this.hzReUrl;
      if (this.userType === 'shandong') {
        goto = this.sdReUrl;
      } else if (this.userType === 'shandong2') {
        goto = this.sd2ReUrl;
      } else if (this.userType === 'shandong3') {
        goto = this.sd3ReUrl;
      } else if (this.userType === 'shandong4') {
        goto = this.sd4ReUrl;
      }
      this.$nextTick(() => {
        const id = `login_container_${this.userType}`
        // 首先吧id里面的元素滞空
        const nodes = document.getElementById(id)
        nodes.replaceChildren()
        this.QRLoginObj = QRLogin({
          id:id,
          goto: goto,
          width: '100%',
          height: '300',
          style: 'border:none;background-color:#ffffff;',

        });
        window.addEventListener('message', this.handleMessage, false);
      });
    },
  },
  created() {
    this.activeName = window.localStorage.getItem('operate_front_user_type') || '2';

    if (window.location.href.includes('user_type') && window.location.href.includes('code') && window.location.href.includes('state') && window.location.href.includes('unique_flag')) {
      if (window.location.href.includes('forbidden')) {
        this.$message.error('为了您可以正常使用后台，请立刻切换到火狐浏览器!');
        this.scanLogin();
      } else if (this.$route.query.errCode == '997') {
        this.$notify({
          title: '检测到尚未进行人脸识别验证',
          dangerouslyUseHTMLString: true,
          message: '<div><p>如果您在公司办公，请点击<a href="http://insideworksn.hzwxbz2.cn" style="color:#409EFF">内网地址</a>进行登录</p><p>如果您不在公司办公，请先打开飞书应用进行人脸识别;</p></div>'
        });
        const _url = `${window.location.origin}${window.location.pathname}`;
        window.history.replaceState({}, '0', _url);
      } else if (window.location.href.includes('errMsg')) {
        this.$message.error(this.$route.query.errMsg);
        const _url = `${window.location.origin}${window.location.pathname}`;
        window.history.replaceState({}, '0', _url);
      } else {
        this.scanLogin();
      }
    }
    // 接入飞书新的授权登录方式
    this.getFeishuAuthLogin()

  },
  methods: {

     // 确认是否是飞书授权登录
    async getFeishuAuthLogin  ()  {
      const params = getCommonFeishuAuthLogin();
      // 没有参数就说明不是手动授权登录，或者没拿到对应参数
      if (!params) return;
      console.log(params)
      const { authorizedCode, redirectUri } = params;
      if (authorizedCode) {
        try {
          const user_type = localStorage.getItem('operate_front_user_type');
          // 兼容一下账号登录的情况，如果取到是账号登录的话，取当前默认的地区类型
          const params = {
            redirectUri: redirectUri,
            authorizedCode: authorizedCode,
            tenantType: areaMap[user_type] || 'hangzhou',
          } ;
          const r = await feishuAuthLogin(params);
          


          // console.log(r)
          if (r.data.code !== 200) {
            this.$message({
              message: r.data.message + '，请重新扫码登录',
              type: 'error',
            });
            this.$router.push({ path: '/login' });
            return;
          }
          localStorage.removeItem('unique_flag');
          localStorage.setItem('hide_page', r.data.data.hide_page);
          let hide_page = r.data.data.hide_page;
          setToken(r.data.data.token);
          setAdminId(r.data.data.admin_id);
          window.removeEventListener('message', this.handleMessage, false);
          //  获取用户信息
          getUserInfo().then((response) => {
              // console.log('response', response)
              // console.log(this.redirect || '/dashboard')
              setName(response.data.name);
              setRoles(JSON.stringify(response.data.roles));
              this.loading = false;
              this.$router.push({ path: hide_page == 1 ? '/ordinaryReport' : (this.redirect || '/dashboard') });
              localStorage.removeItem('unique_flag');
            }).catch((error) => {
              removeToken();
              // console.log(1111)
              this.$router.push({ path: '/login' });
            });



        } catch (error) {
          const _url = `${window.location.origin}${window.location.pathname}`;
          window.history.replaceState({}, '0', _url);
        }
      }
    },
    onTabchange  (val) {
      localStorage.setItem('operate_front_user_type', val.name);
    },
    onFsAuthLogin() {
     
      onCommonFsAuthLogin({
        appidEnum: provinceListAppid,
        userType:this.activeName
      });
    },
    // 账号密码登录
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          loginByUsername(this.loginForm.username, this.loginForm.password)
            .then((response) => {
              response = response.data;
              setToken(response.data.token);
              setAdminId(response.data.admin_id);
              localStorage.setItem('hide_page', response.data.hide_page);
              let hide_page = response.data.hide_page;
              //  获取用户信息
              getUserInfo()
                .then((response) => {
                  setName(response.data.name);
                  setRoles(JSON.stringify(response.data.roles));
                  this.loading = false;
                  this.$router.push({ path: hide_page == 1 ? '/ordinaryReport' : (this.redirect || '/dashboard') });
                })
                .catch((error) => {
                  removeToken();
                  this.loading = false;
                });
            })
            .catch((error) => {
              console.log(error);
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 初始化飞书二维码
    async initFeiShu() {
      if (this.userType === 'hangzhou' && this.hzReUrl !== '') return;
      if (this.userType === 'shandong' && this.sdReUrl !== '') return;
      if (this.userType === 'shandong2' && this.sd2ReUrl !== '') return;
      if (this.userType === 'shandong3' && this.sd3ReUrl !== '') return;
      if (this.userType === 'shandong4' && this.sd4ReUrl !== '') return;
      const r = await getFeishuUrl({ user_type: this.userType });
      if (r.data.code !== 200) {
        this.$message({
          message: data.message,
          type: 'error',
        });
        return;
      }
      if (this.userType === 'hangzhou') {
        this.hzReUrl = r.data.data.url;
        this.hz_unique_flag = r.data.data.unique_flag;
      }
      if (this.userType === 'shandong') {
        this.sdReUrl = r.data.data.url;
        this.sd_unique_flag = r.data.data.unique_flag;
      }
      if (this.userType === 'shandong2') {
        this.sd2ReUrl = r.data.data.url;
        this.sd2_unique_flag = r.data.data.unique_flag;
      }
      if (this.userType === 'shandong3') {
        this.sd3ReUrl = r.data.data.url;
        this.sd3_unique_flag = r.data.data.unique_flag;
      }
      if (this.userType === 'shandong4') {
        this.sd4ReUrl = r.data.data.url;
        this.sd4_unique_flag = r.data.data.unique_flag;
      }
    },
    // 手机点击确认飞书登录后的回调，跳转到飞书登录公共平台
    handleMessage(event) {
      var origin = event.origin;
      // 使用 matchOrigin 方法来判断 message 是否来自飞书页面
      if (this.QRLoginObj.matchOrigin(origin)) {
        var loginTmpCode = event.data;
        let reUrl = this.hzReUrl;
        let unique_flag = this.hz_unique_flag;
        if (this.userType === 'shandong') {
          reUrl = this.sdReUrl;
          unique_flag = this.sd_unique_flag;
        } else if (this.userType === 'shandong2') {
          reUrl = this.sd2ReUrl;
          unique_flag = this.sd2_unique_flag;
        } else if (this.userType === 'shandong3') {
          reUrl = this.sd3ReUrl;
          unique_flag = this.sd3_unique_flag;
        } else if (this.userType === 'shandong4') {
          reUrl = this.sd4ReUrl;
          unique_flag = this.sd4_unique_flag;
        }

        // 获取到loginTmpCode后就可以构造链接
        let enReUrl = `${reUrl}&tmp_code=${loginTmpCode}`;
        enReUrl = encodeURIComponent(enReUrl);
        // 对跳转的from_url 进行Base64的编码
        let from_url = Base64.encode(window.location.href.split('//')[1]);
        const replaceArr = [
          { key: /\+/g, value: '%2B' },
          { key: /\=/g, value: '&3D' },
          { key: /\&/g, value: '%26' },
          { key: /\//g, value: '%2F' },
          { key: /\#/g, value: '%23' },
          { key: /\?/g, value: '%3F' },
          { key: /\%/g, value: '%25' },
        ];
        for (const item of replaceArr) from_url = from_url.replace(item.key, item.value);
        localStorage.setItem('unique_flag', unique_flag);
        // 跳转到飞书登录公共平台
        let baseDingUrl = `${getBaseUrl()}?re_url=${enReUrl}&from_url=${encodeURIComponent(from_url)}`;
        window.location.href = baseDingUrl;
      }
    },
    // 飞书扫码登录获取用户信息
    async scanLogin() {
      if (!localStorage.getItem('unique_flag')) return;
      const r = await feiLogin({ unique_flag: localStorage.getItem('unique_flag') || '' });
      // console.log(r)
      if (r.data.code !== 200) {
        this.$message({
          message: r.data.message + '，请重新扫码登录',
          type: 'error',
        });
        this.$router.push({ path: '/login' });
        return;
      }
      localStorage.removeItem('unique_flag');
      localStorage.setItem('hide_page', r.data.data.hide_page);
      let hide_page = r.data.data.hide_page;
      setToken(r.data.data.token);
      setAdminId(r.data.data.admin_id);
      window.removeEventListener('message', this.handleMessage, false);
      //  获取用户信息
      getUserInfo().then((response) => {
          // console.log('response', response)
          // console.log(this.redirect || '/dashboard')
          setName(response.data.name);
          setRoles(JSON.stringify(response.data.roles));
          this.loading = false;
          this.$router.push({ path: hide_page == 1 ? '/ordinaryReport' : (this.redirect || '/dashboard') });
          localStorage.removeItem('unique_flag');
        }).catch((error) => {
          removeToken();
          // console.log(1111)
          this.$router.push({ path: '/login' });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
// 飞书登录

.el-image {
  width: 25px;
  height: 25px;
  margin-right: 8px;
  transition: all 0.3s ease;
}
.fs-code-login-btn {
  // margin-bottom: 20px;
  // width: 100%;
  // height: 36px;
  // padding: 16px;
}


.login-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../../assets/img/login-bg.jpg);
  background-size: 100%;
  background-position: 50%;
}
.ms-title {
  border-bottom: 1px solid #ddd;
  font-size: 14px;
  color: #17233d;
  font-weight: 700;
  padding: 14px 16px;
}
.ms-login {
  position: absolute;
  right: 160px;
  top: 50%;
  width: 300px;
  max-height: 400px;
  margin: -190px 0 0 -175px;
  border-radius: 5px;
  background: #fff;
  overflow: hidden;
}
.ms-content {
  padding: 16px;
}
.login-btn {
  text-align: center;
}
.login-btn button {
  width: 100%;
  height: 36px;
  margin-bottom: 10px;
}
.login-tips {
  font-size: 12px;
  line-height: 30px;
  color: #fff;
}
.ms_username {
  padding: 10px 0 0;
  margin-bottom: 24px;
}
.ms_username2 {
  margin-bottom: 24px;
}
.login-feishu-button {
  width: 100%;
  height: 40px;
  padding: 2px 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 40px;
}
</style>
<style>
.login_qrcode_content {
  margin-top: 0px;
}
</style>


